import { LocationInfo } from '../common';
import { CompoundOrigin, CompoundTranslationType, DataQuality, PolygonType, RemovalReason, ScreeningFlag, ScreeningStatus } from '../enums';
import { Industry } from './industry';
import { Activity } from './activity';
import { ScreeningStandardparameters } from './screening-standard-parameters';
import { ScreeningPolygonResult } from './screening-polygon-result';
export class PreliminaryScreeningLocationDetailView {
    public id: string;
    public location: LocationInfo;
    public hasV1Polygon: boolean;
    public hasV2Polygon: boolean;
    public v1PolygonResult: ScreeningPolygonResult;
    public v2PolygonResult: ScreeningPolygonResult;
    public v1PreliminaryScreenings: Array<PreliminaryScreeningLocationResultItem>;
    public v2PreliminaryScreenings: Array<PreliminaryScreeningLocationResultItem>;

    public constructor(init: Partial<PreliminaryScreeningLocationDetailView>) {
        Object.assign(this, init);
    }
}

export class PreliminaryScreeningLocationResultItem {
    public id: string;
    public createdAt: Date;
    public status: ScreeningStatus;
    public industry: Industry; // For V1 polygons
    public activity: Activity; // For V1 polygons
    public compoundName: string;
    public compoundCasNr: string;
    public qualityCriterion: number;
    public worstCaseConcentration: number;
    public concentrationDownstream: number;
    public removed: boolean;
    public removalReason: RemovalReason;
    public factor: number;
    public dataQuality: DataQuality;
    public flag: ScreeningFlag;
    public polygonArea: number;
    public polygonType: PolygonType;
    public standardParameters: ScreeningStandardparameters;
    public compoundOrigin: CompoundOrigin;
    public compoundTranslationType: CompoundTranslationType;
}
